<script>
  import currentUser from './stores/auth';
  import {Router, Route, navigate} from "svelte-routing";

  import Header from './components/Header.svelte'
  import MainPage from './pages/HomePage.svelte'
  import ProjectsPage from './pages/ProjectsPage.svelte'
  import ProjectPage from './pages/ProjectPage.svelte'
  import LoginPage from './pages/LoginPage.svelte'
  import PasswordResetPage from './pages/PasswordResetPage.svelte'
  import AdmHomePage from './pages/Admin/HomePage.svelte';
  import AdmProjectEdit from './pages/Admin/ProjectEditPage.svelte'

  let url = "";

  function onAuthStateChanged(state) {
    if (state && state.event && state.event === 'PASSWORD_RECOVERY')
      navigate('/admin/home');
  }

  $: onAuthStateChanged($currentUser);
</script>


<div class="container">
  <Router {url}>
    <Header/>

    <main>
      <Route path="projects" component="{ProjectsPage}"/>
      <Route path="project/:id" component="{ProjectPage}"/>
      <Route path="login" component={LoginPage}/>
      <Route path="password-reset" component={PasswordResetPage}/>
      <Route path="admin/home" component="{AdmHomePage}"/>
      <Route path="admin/project/:id/edit" component="{AdmProjectEdit}"/>
      <Route path="/" component={MainPage}/>
    </main>
  </Router>
</div>

<footer>Created by <a href="https://github.com/motzel">motzel</a></footer>

<style>
  .container {
      margin: 0 auto;
      max-width: 1024px;
  }

  main {
      position: relative;
      margin-top: 2rem;
  }

  footer {
      margin: 4rem 0;
      font-size: 8px;
      text-align: center;
  }

  :global(.pulse) {
      animation: pulse 1.5s infinite;
  }

  @keyframes pulse {
      0% {
          opacity: 1;
      }

      50% {
          opacity: 0.25;
      }

      100% {
          opacity: 1
      }
  }
</style>